import React from "react";
import { Link, NavLink } from "react-router-dom";

const Service = () => {
  return (
    <>
      {/* ERP Business Software */}
      <li>
        <NavLink to="/services/erp-business-software">ERP Business Software</NavLink>
      </li>

      {/* Design */}
      <li>
        <NavLink to="/services/web-design">Web Design</NavLink>
      </li>

      {/* Frontend */}
      <li>
        <NavLink to="/services/web-development">Frontend Development</NavLink>
      </li>

      {/* Digital Marketing */}
      <li>
        <NavLink to="/services/digital-marketing">Digital Marketing</NavLink>
      </li>

      {/*Web App Development*/}
      <li>
        <NavLink to="/services/web-application-development">Web App Development</NavLink>
      </li>
      {/*Video Editing Marketing*/}
      <li>
        <NavLink to="/services/video-editing-marketing">Video Editing Marketing</NavLink>
      </li>
    </>
  );
};

export default Service;
